import React, { Component } from 'react';

class Animation extends Component {
  componentDidMount() {
    this._onScroll = this._scrollingHandler.bind(this);
    window.addEventListener('scroll', this._onScroll);
  }

  _scrollingHandler() {
    const element = document.getElementsByClassName('genericHeaderContainer');
    const ele = document.getElementsByClassName('animation');
    // const intialELe = document.getElementById('initial');
    const icon = document.getElementById('icon');
    const scrollELe = document.getElementById('scroll');
    const rightELe = document.getElementsByClassName('rightHeaders');
    if (window.scrollY >= 5) {
      if (element[0]) {
        element[0].classList.add('header-after-scroll');
        if (ele[0]) {
          rightELe[0].classList.remove('slide-bottom');
          rightELe[0].classList.add('slide-top');
          // intialELe.classList.add('hide');
          if (icon) {
            icon.classList.add('hide');
          }
          ele[0].classList.remove('initial-header');
          ele[0].classList.remove('fw-700');
          ele[0].classList.remove('font-26');
          scrollELe.classList.remove('slide-bottom');
          ele[0].classList.add('slide-top'); // 'expand-fwd-bottom'
          // intialELe.classList.remove('slide-bottom'); // expand-fwd-top
        }
      }
    } else if (element[0]) {
      element[0].classList.remove('header-after-scroll');
      if (ele[0]) {
        // intialELe.classList.remove('hide');
        rightELe[0].classList.remove('slide-top');
        rightELe[0].classList.add('slide-bottom');
        // scrollELe.classList.add('hide');
        if (ele[0].classList.contains('slide-top')) {
          ele[0].classList.remove('slide-top');
          if (icon && icon.classList.contains('hide')) {
            icon.classList.remove('hide');
          }
          ele[0].classList.add('initial-header');
          ele[0].classList.add('fw-700');
          ele[0].classList.add('font-26');
          scrollELe.classList.add('slide-bottom');
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._onScroll);
  }

  render() {
    return '';
  }
}

export default Animation;
